<div class="dialog-wrapper">
  <i class="fas fa-times modal-close" (click)="closeModal()"></i>
  <app-carousel [slides]="slides" [currentSlide]="currentSlide"></app-carousel>
</div>
